import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { CreateFournisseurAgree } from "../../core/model/fournisseuragree/create-fournisseur-agree";
import { MarcheDTO } from "../../core/model/marche/marche-dto";
import { MarcheService } from "../../core/service/marche.service";
import { FournisseurAgreeService } from "../../core/service/fournisseur-agree.service";

@Component({
  selector: "app-add-fournisseur-agree",
  templateUrl: "./add-fournisseur-agree.component.html",
  styleUrls: ["./add-fournisseur-agree.component.scss"],
})
export class AddFournisseurAgreeComponent implements OnInit {
  createFournisseurAgree: CreateFournisseurAgree = new CreateFournisseurAgree();
  marches: MarcheDTO[];

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _marcheService: MarcheService,
    private _fournisseurAgreeService: FournisseurAgreeService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      marcheId: [null, Validators.compose([Validators.required])],
      codeClient: [null, Validators.compose([Validators.required])],
      numeroRct: [null, Validators.compose([Validators.required])],
      nomComplet: [null, Validators.compose([Validators.required])],
      limiteAutorisee: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getMarches();
  }

  getMarches() {
    this._marcheService.findAll().subscribe(
      (data) => {
        this.marches = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this.pressButton = true;
    this._fournisseurAgreeService
      .add(this.createFournisseurAgree)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
